import { render } from "./WelcomeServiceList.vue?vue&type=template&id=4a906a1b"
const script = {}
script.render = render

export default script